import { useState } from 'react';
import DocumentTab from './DocumentTab';
import InvoiceTab from './InvoiceTab';
import VisaTab from './VisaTab';
// import StatusModel from './StatusModel';

export default function Tabs({selectedData, onRefresh, forceChecklistRefresh = false}) {
  const [activeTab, setActiveTab] = useState('documents');
  // const [statusPopus, setStatusPopup] = useState(false)
  const tabs = [
    { key: 'documents', label: 'Documents' },
    { key: 'invoice', label: 'Invoice' },
    { key: 'visaStatus', label: 'Visa Status' },
  ];

  return (
    <div className="mt-6">
      <div className="flex gap-2">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={`p-2 md:px-6 md:py-3 w-36 text-sm font-medium rounded-t-xl ${
              activeTab === tab.key
                ? 'bg-[#FFFBF5] border border-gray-500 border-b-0'
                : 'bg-gray-200'
            }`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === 'documents' && (
        <DocumentTab
          selectedData={selectedData}
          onRefresh={onRefresh}
          forceChecklistRefresh={forceChecklistRefresh}
        />
      )}
      {activeTab === 'invoice' && <InvoiceTab selectedData={selectedData} onRefresh={onRefresh} />}
      {activeTab === 'visaStatus' && <VisaTab selectedData={selectedData} />}
      {/* {statusPopus && <StatusModel setStatusPopup={setStatusPopup}/>} */}
    </div>
  );
}